import { useEffect, useState } from "react";

const Preloader = ({ isLoading }) => {
  const [active, setActive] = useState(true);

  useEffect(() => {
    if (typeof isLoading === "boolean") {
      setActive(isLoading);
    } else {
      // Default behavior if isLoading is not provided
      const timer = setTimeout(() => {
        setActive(false);
      }, 500);

      return () => clearTimeout(timer); // Clear timeout on component unmount
    }
  }, [isLoading]);

  return (
    <>
      {active ? (
        <div className="preloader">
          <img src="assets/images/icon/preloader.gif" alt="Loading..." />
        </div>
      ) : null}
    </>
  );
};

export default Preloader;
